import { data } from "../data";

const TOGGLE_CONTINUE = "TOGGLE_CONTINUE";
const TOGGLE_QUESTIONS = "TOGGLE_QUESTIONS";
export const toggleContinue = () => ({
  type: TOGGLE_CONTINUE,
});
export const toggleQuestions = () => ({
  type: TOGGLE_QUESTIONS,
});

const SET_INDEX = "SET_INDEX";
export const setIndex = (index) => ({
  type: SET_INDEX,
  index,
});

const SET_PLAYER = "SET_PLAYER";
export const setPlayer = (player) => ({
  type: SET_PLAYER,
  player,
});

const TOGGLE_CHAPTERS = "TOGGLE_CHAPTERS";
export const toggleChapters = () => ({
  type: TOGGLE_CHAPTERS,
});

const TOGGLE_LANGUAGES = "TOGGLE_LANGUAGES";
export const toggleLanguages = () => ({
  type: TOGGLE_LANGUAGES,
});

const CLOSE_MODALS = "CLOSE_MODALS";
export const closeModals = () => ({
  type: CLOSE_MODALS,
});

export const initialState = {
  index: 0,
  currentItem: data[0],
  player: null,
  continueShowing: false,
  questionsShowing: false,
  chaptersShowing: false,
  languagesShowing: false,
};

export const Reducer = (state, action) => {
  switch (action.type) {
    case TOGGLE_CONTINUE:
      return {
        ...state,
        continueShowing: !state.continueShowing,
      };
    case TOGGLE_QUESTIONS:
      return {
        ...state,
        questionsShowing: !state.questionsShowing,
      };
    case SET_INDEX:
      const item = data[action.index];
      return {
        ...state,
        index: action.index,
        currentItem: item,
      };
    case SET_PLAYER:
      return {
        ...state,
        player: action.player,
      };
    case TOGGLE_CHAPTERS:
      return {
        ...state,
        chaptersShowing: !state.chaptersShowing,
      };
    case TOGGLE_LANGUAGES:
      return {
        ...state,
        languagesShowing: !state.languagesShowing,
      };
    case CLOSE_MODALS:
      return {
        ...state,
        continueShowing: false,
        questionsShowing: false,
        chaptersShowing: false,
        languagesShowing: false,
      };
    default:
      console.log(action.type);
      console.log("No matching action type");
      return state;
  }
};
